import sentimentAPI from './sentimentAPI';

// Existing action types...
export const FETCH_SENTIMENT_BEGIN = 'FETCH_SENTIMENT_BEGIN';
export const FETCH_SENTIMENT_SUCCESS = 'FETCH_SENTIMENT_SUCCESS';
export const FETCH_SENTIMENT_FAILURE = 'FETCH_SENTIMENT_FAILURE';

// === NEW FOR BATCH ===
export const FETCH_BATCH_SENTIMENT_BEGIN = 'FETCH_BATCH_SENTIMENT_BEGIN';
export const FETCH_BATCH_SENTIMENT_SUCCESS = 'FETCH_BATCH_SENTIMENT_SUCCESS';
export const FETCH_BATCH_SENTIMENT_FAILURE = 'FETCH_BATCH_SENTIMENT_FAILURE';

/**
 * Fetch sentiment data from the backend for a given symbol (single ticker)
 * @param {string} symbol
 */
export const fetchSentimentData = (symbol) => async (dispatch) => {
  dispatch({ type: FETCH_SENTIMENT_BEGIN });

  try {
    const data = await sentimentAPI.fetchNewsSentiment(symbol);
    dispatch({
      type: FETCH_SENTIMENT_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_SENTIMENT_FAILURE,
      payload: error.message || 'Failed to fetch sentiment data',
    });
  }
};

/**
 * Fetch batch news sentiment data for a list of tickers
 * @param {string[]} tickers
 * @param {number} limit
 */
export const fetchBatchSentimentData = (tickers, limit = 20) => async (dispatch) => {
  dispatch({ type: FETCH_BATCH_SENTIMENT_BEGIN });

  try {
    const data = await sentimentAPI.fetchBatchNewsSentiment(tickers, limit);
    dispatch({
      type: FETCH_BATCH_SENTIMENT_SUCCESS,
      payload: data, // should be flat array
    });
  } catch (error) {
    dispatch({
      type: FETCH_BATCH_SENTIMENT_FAILURE,
      payload: error.message || 'Failed to fetch batch sentiment data',
    });
  }
};
